import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "../config";

export const companyInviteApi = createApi({
  reducerPath: "companyInviteApi",
  baseQuery: createBaseQuery("/c/invites"),
  tagTypes: ["companyInviteApis"],
  endpoints: (build) => ({
    loadInvites: build.query<
      CompanyInvite[],
      { companyId: number; search: string }
    >({
      query: ({ companyId, search }) => ({
        url: `/${companyId}`,
        method: "GET",
        params: { search: search },
      }),
      providesTags: ["companyInviteApis"],
    }),
    addInvite: build.mutation<
      CompanyInviteData,
      { companyId: number; data: CompanyInviteData }
    >({
      query: ({ companyId, data }) => ({
        url: `/${companyId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["companyInviteApis"],
    }),
    editInvite: build.mutation<
      CompanyInviteData,
      { companyId: number; inviteId: number; data: CompanyInviteData }
    >({
      query: ({ companyId, inviteId, data }) => ({
        url: `/${companyId}/${inviteId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["companyInviteApis"],
    }),
    updateInviteStatus: build.mutation<
      CompanyInvite,
      { data: CompanyInviteStatusData }
    >({
      query: ({ data }) => ({
        url: `/update-status`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["companyInviteApis"],
    }),
  }),
});
